import { render } from "./TicketPage.vue?vue&type=template&id=54007b3a&scoped=true"
import script from "./TicketPage.vue?vue&type=script&lang=js"
export * from "./TicketPage.vue?vue&type=script&lang=js"

import "./TicketPage.vue?vue&type=style&index=0&id=54007b3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54007b3a"]])

export default __exports__